<hpf-audio-form
        *ngIf="audio"
        [audio]="audio"
        (create)="onCreate($event)"
    ></hpf-audio-form>
<div *ngIf="!audio" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>